export default "__VITE_ASSET__D3gg_6c5__"